// Field classification for smart dashboard auto-grouping

const IDENTITY_WORDS = ['name', 'emp', 'email', 'department', 'company', 'joining', 'job title', 'designation', 'date of', 'current company', 'filled by', 'id'];
const PERF_WORDS = ['rating', 'skill', 'performance', 'adaptab', 'problem', 'punctual', 'attendance', 'accountab', 'reliab', 'professionalism', 'ethic', 'objective', 'eagerness', 'learn', 'flexibility', 'achievement', 'expectation', 'responsib', 'how would you rate', 'did the employee'];
const COMP_WORDS = ['salary', 'increment', 'payout', 'compensation', 'recommend', 'approval', 'letter issued', 'start date', 'management'];
const REMARK_WORDS = ['remark', 'complaint', 'issue', 'project', 'recognition', 'special', 'review period', 'added time', 'comfortable', 'ready to', 'overall', 'other'];

function matchesAny(fieldName, words) {
  const lower = fieldName.toLowerCase();
  return words.some(w => lower.includes(w));
}

export function classifyField(fieldName) {
  if (matchesAny(fieldName, IDENTITY_WORDS)) return 'identity';
  if (matchesAny(fieldName, PERF_WORDS)) return 'performance';
  if (matchesAny(fieldName, COMP_WORDS)) return 'compensation';
  if (matchesAny(fieldName, REMARK_WORDS)) return 'remarks';
  return 'remarks';
}

export const SECTION_DEFS = [
  { key: 'identity', label: 'Employee Information' },
  { key: 'performance', label: 'Performance Ratings' },
  { key: 'compensation', label: 'Increment & Compensation' },
  { key: 'remarks', label: 'Remarks & Other' },
];

export function groupFieldsIntoSections(payload) {
  const groups = {};
  SECTION_DEFS.forEach(s => { groups[s.key] = []; });

  Object.entries(payload).forEach(([key, val]) => {
    const section = classifyField(key);
    groups[section].push({ key, value: val });
  });

  return SECTION_DEFS.map(s => ({
    ...s,
    fields: groups[s.key],
  })).filter(s => s.fields.length > 0);
}

export function isRatingValue(val) {
  const str = String(val).trim();
  const num = parseFloat(str);
  return !isNaN(num) && num >= 1 && num <= 10 && str === String(num);
}
